import { useEffect, useState } from "react";

import { Centered } from "@/components/ui/container";
import { Loader } from "@/components/ui/loader";

export function LoadingPage() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const id = setTimeout(() => setShow(true), 100);
    return () => clearTimeout(id);
  }, []);

  return <Centered>{show ? <Loader size="medium" /> : null}</Centered>;
}
